import { createContext, useContext, useState } from "react";
import Modal from "react-bootstrap/Modal";

// Create a Context for the modal
const ModalContext = createContext();

// Provider component that wraps your app and provides the modal functionality
export const ModalProvider = ({ children }) => {
  // State to manage modal properties: visibility, title, and content.
  const [modalProps, setModalProps] = useState({
    show: false,
    title: "",
    content: "",
    size: "md",
    hideHeader: false, // optional prop
  });

  // Function to display the modal.
  // It now accepts two objects for title and content.
  const showModal = (titleObj, contentObj, sizeObj, hideHeader) => {
    setModalProps({
      show: true,
      title: titleObj.title,
      content: contentObj.content,
      size: sizeObj?.size || "md", // optional prop
      hideHeader: hideHeader?.hideHeader || false, // optional prop
    });
  };

  // Function to hide the modal.
  const hideModal = () => {
    setModalProps((prevState) => ({
      ...prevState,
      show: false,
    }));
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <Modal
        show={modalProps.show}
        onHide={hideModal}
        centered
        size={modalProps.size}
      >
        {modalProps?.hideHeader === true ? null : (
          <Modal.Header closeButton style={{ border: "none" }}></Modal.Header>
        )}
        <Modal.Body
          style={{
            padding: "1rem",
            maxWidth: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              fontSize: 20,
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {modalProps.title}
          </div>
          <div style={{ fontSize: 16, margin: 4 }}>{modalProps.content}</div>
        </Modal.Body>
      </Modal>
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  return useContext(ModalContext);
};
